export default function Spacer({
  width = 0,
  height = 0,
}: {
  width?: number;
  height?: number;
}) {
  return <div style={{ width, height }} />;
}
